export const formatDateTime = (dateString) => {
  if (!dateString) return '';

  return new Date(dateString).toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true, // optional
  });
};

  export const formatTo12Hour = (time) => {
  if (!time) return "";

  const [hours, minutes] = time.split(":");
  const hour = parseInt(hours, 10);

  const ampm = hour >= 12 ? "PM" : "AM";
  const formattedHour = hour % 12 || 12;

  return `${formattedHour}:${minutes} ${ampm}`;
};

export const calculateAge = (birthDay) => {
  if (!birthDay) return null;

  const birth = new Date(birthDay);
  const today = new Date();

  let age = today.getUTCFullYear() - birth.getUTCFullYear();

  const hasHadBirthdayThisYear =
    today.getUTCMonth() > birth.getUTCMonth() ||
    (today.getUTCMonth() === birth.getUTCMonth() &&
      today.getUTCDate() >= birth.getUTCDate());

  if (!hasHadBirthdayThisYear) age--;

  return age;
};